<!-- 文件中文名: 促销选择页 -->
<template>
  <div class="PromotionOptions app-container">
    <el-divider content-position="left">
      <!--促销选择-->
      <span style="color: #B1821D">{{ $t('PromotionSelect') }}</span>
    </el-divider>
    <el-table
        :data="PromotionData"
        fit
        :show-header="false"
        default-expand-all
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              v-if="props.row.items.isGoods===1"
              :data="props.row.items"
              border
              fit
              style="width: 90%;margin: 0 auto">
            <!--购买次数-->
            <el-table-column :label="$t('PurchasesNumber')">
              <template slot-scope="{ row }">
                <el-input-number
                    v-model="row.buyQty"
                    :disabled="!row.buyType"
                    :min="0"
                    :step="1"
                    style="width: 100%"
                    controls-position="right"
                    @change="buyTypeChange(row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <!--商品名称-->
            <el-table-column prop="goodsName" :label="$t('BiGoods.name')"/>
            <!--额外支付-->
            <el-table-column :label="$t('ExtraPay')">
              <template slot-scope="{ row }">
                <span style="display: block">{{ row.unitAmount }}W$</span>
                <span style="display: block">{{ row.unitFv }}Pv</span>
                <span style="display: block">{{ row.pointa0 }}{{ $t('bvPointChange.updatePoint.1') }}</span>
              </template>
            </el-table-column>
            <!--购买数量-->
            <el-table-column prop="quantity" :label="$t('Common.buyNumber')"/>
            <!--商品编码-->
            <el-table-column prop="goodscode" :label="$t('BiGoods.goodsCode')"/>
          </el-table>
          <el-table
              v-if="props.row.items.isGoods===0"
              :data="props.row.items"
              border
              fit
              style="width: 90%;margin: 0 auto">
            <!--购买数量-->
            <el-table-column :label="$t('Common.buyNumber')">
              <template slot-scope="{ row }">
                <el-input-number
                    v-model="row.buyQty"
                    :min="0"
                    :step="1"
                    style="width: 100%"
                    controls-position="right"
                    @change="buyTypeChange(row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <!--标题-->
            <el-table-column prop="title" :label="$t('icInformation.title')"/>
          </el-table>
        </template>
      </el-table-column>
      <!--促销名称-->
      <el-table-column prop="title" :label="$t('PromotionTitle')"></el-table-column>
      <el-table-column>
        <template slot-scope="{ row }">
          <p :class="selectedQty(row.items) > row.giveQty ? 'err-text': ''">
            <!--可买次数  已选-->
            {{$t('CanBePurchasedNum')}}: {{ row.giveQty }}
            {{$t('BeSelected')}}: {{ selectedQty(row.items) }}
          </p>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;color: #B1821D;margin-top: 10px">
      <!--额外支付-->
      {{$t('ExtraPay')}}: {{ unitAmount }}$ {{ unitFv }}PV {{ pointa0 }}{{ $t('bvPointChange.updatePoint.1') }}
    </div>
    <div style="text-align: center;margin: 10px 0">
      <!--上一步-->
      <el-button
          icon="el-icon-back"
          size="mini"
          @click="goBack"
      >
        {{ $t('button.previous') }}
      </el-button>
      <!--下一步-->
      <el-button
          icon="el-icon-right"
          size="mini"
          type="success"
          @click="goOrderSettle()"
      >
        {{ $t('button.next') }}
      </el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PromotionOptions',
  components: {},
  filters: {},
  props: {
    typeNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      PromotionData: null,
      unitAmount: 0,
      unitFv: 0,
      pointa0: 0
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {
  },
  created() {
    if (!sessionStorage.getItem("PromotionData")) {
      console.log('PromotionData不存在!')
      this.$router.go(-1)
    }
    this.PromotionData = JSON.parse(sessionStorage.getItem("PromotionData"))

    this.unitAmount = 0
    this.unitFv = 0
    this.pointa0 = 0
    this.PromotionData.forEach(item => {
      item.selectedQty = 0
      item.items.isGoods = item.items[0].isGoods
      console.log(item.items.isGoods, 'item.items.isGoods')
      item.items.forEach(item1 => {
        // item1.buyQty = 0
        if (item1.buyType !== 0) {
          item1.buyQty = 0
        }
        item.selectedQty += item1.buyQty
      })
    })
    console.log(this.PromotionData, 'PromotionData')
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    buyTypeChange(row) {
      const buyQtyStr = String(row.buyQty).trim()
      const buyQtyNum = parseInt(buyQtyStr, 10)
      if (isNaN(buyQtyNum) || buyQtyNum < 0) {
        this.$set(row, 'buyQty', 0)
        this.$forceUpdate()
      }
      this.unitAmount = 0
      this.unitFv = 0
      this.pointa0 = 0
      for (const item of this.PromotionData) {
        item.items.forEach(item1 => {
          this.unitAmount += item1.buyQty * item1.unitAmount
          this.unitFv += item1.buyQty * item1.unitFv
          this.pointa0 += item1.buyQty * item1.pointa0
        })
      }
    },
    selectedQty(items) {
      let qty = 0
      items.forEach(item => {
        qty += item.buyQty
      })
      return qty
    },
    async goOrderSettle() {
      let cuxiaomxList = []
      for (const item of this.PromotionData) {
        if (this.selectedQty(item.items) > item.giveQty) {
          return this.$message.error(`${item.title} `+ this.$t('Exceeded.Quantity.Modify').toString() + '!')
        }
        if (this.selectedQty(item.items) < item.giveQty) {
          let tipMessage = this.$t('PromotionTip2').toString()
          try {
            await this.$confirm(tipMessage, tipMessage, {
              confirmButtonText: this.$t('yesno.yes').toString(),
              cancelButtonText: this.$t('yesno.no').toString(),
              customClass: 'msgBox',
              type: 'warning'
            })
          } catch (error) {
            console.log(error)
            return
          }
        }
        for (const item1 of item.items) {
          if (item1.buyQty > 0) {
            cuxiaomxList.push(item1)
          }
        }
      }
      console.log(cuxiaomxList, 'cuxiaomxList')
      sessionStorage.setItem('CuxiaomxList', JSON.stringify(cuxiaomxList))
      let MemberRegisterData = JSON.parse(sessionStorage.getItem("MemberRegisterData"))
      if (MemberRegisterData) {
        await this.$router.push({path: '/member-register/member-register-settle'})
      } else {
        await this.$router.push({path: '/order-settle'})
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}

</script>

<style scoped lang="scss">
.PromotionOptions {
  text-align: left;

  .checkbox-item {
    display: block;
    margin: 10px 10px;
  }

  .checkbox-item:first-child {
    margin: 0 10px 10px 10px;
  }
  .err-text {
    color: red;
  }
}
</style>
